import { Fragment, useState } from "react"
import { SearchableSelect, TextField } from "components/Core"
import useSearchMiddlewareOSRM from "hooks/useSearchMiddlewareOSRM"

interface IPropsCriteriasScheduleOrder {
  control: any
  errors: any
  setValue: any
  watch: any
}

const CriteriasScheduleOrder = ({ control, errors, watch, setValue }: IPropsCriteriasScheduleOrder) => {
  const { action_search_osrm_action } = useSearchMiddlewareOSRM({})
  const [options, setOptions] = useState<any>([])
  const [isLoadingSearch, setIsLoadingSearch] = useState(false)

  const criterias = {
    c0: "shippingAddress.country",
    c1: "shippingAddress.region",
    c2: "shippingAddress.location.province",
    c3: "shippingAddress.location.commune",
  }

  const criteria0 = watch(criterias.c0)
  const criteria1 = watch(criterias.c1)
  const criteria2 = watch(criterias.c2)
  const criteria3 = watch(criterias.c3)

  const getLocationsAction = async (queryString: string, fields: any, filters: any = {}) => {
    let params = { from: 0, size: 100, queryString, fields, filters }
    try {
      setOptions([])
      setIsLoadingSearch(true)
      let res: any = await action_search_osrm_action("locations", params)
      if (Boolean(res?.data?.message?.total)) {
        let result = res?.data?.message?.records
        setIsLoadingSearch(false)
        return result
      } else {
        setIsLoadingSearch(false)
        return []
      }
    } catch (error) {
      setIsLoadingSearch(false)
      console.log("Error", JSON.stringify(error))
    }
  }

  const sortByName = (items: { name: string }[]) => {
    return items.sort((a, b) => a.name?.localeCompare(b.name))
  }

  const getCriteria0Action = async (queryString: string) => {
    let result = await getLocationsAction(queryString, ["criteria0"])
    result = result?.map((loc: any) => ({ id: loc?.criteria0, name: loc?.criteria0 }))
    result = flatResults(result, "criteria0")
    result = sortByName(result)
    setOptions(result)
    return result
  }

  const getCriteria1Action = async (queryString: string) => {
    setOptions([])
    let result = await getLocationsAction(queryString, ["criteria1"], { criteria0: criteria0?.id })
    result = result?.map((loc: any) => ({ id: loc?.criteria1, name: loc?.criteria1 }))
    result = flatResults(result, "criteria1")
    result = sortByName(result)
    setOptions(result)
    return result
  }

  const getCriteria2Action = async (queryString: string) => {
    setOptions([])
    let result = await getLocationsAction(queryString, ["criteria2", "criteria3"], {
      criteria0: criteria0?.id,
      criteria1: criteria1?.id,
    })
    result = result?.map((loc: any) => ({ id: loc?.criteria2, name: loc?.criteria2 }))
    result = flatResults(result, "criteria2")
    result = sortByName(result)
    setOptions(result)
    return result
  }

  const getCriteria3Action = async (queryString: string) => {
    setOptions([])
    let result = await getLocationsAction(queryString, ["criteria3"], {
      criteria0: criteria0?.id,
      criteria1: criteria1?.id,
      criteria2: criteria2?.id,
    })
    result = result?.map((loc: any) => ({ id: loc?.criteria3, name: loc?.criteria3 }))
    result = flatResults(result, "criteria3")
    result = sortByName(result)
    setOptions(result)
    return result
  }

  const flatResults = (records: any, key: string) => {
    const uniqueValues = new Set(records.map((item: any) => item["id"]))
    return Array.from(uniqueValues).map((value) => {
      const newObj: any = { id: value, name: value, type: key }
      return newObj
    })
  }

  // const clearCriterias = () => {
  //   setValue("shippingAddress.country", "")
  //   setValue("shippingAddress.region", "")
  //   setValue("shippingAddress.location.province", "")
  //   setValue("shippingAddress.location.commune", "")
  // }

  const clear_field = (field: string) => {
    setValue(field, "")
    if (field === criterias.c0) {
      setValue(criterias.c1, "")
      setValue(criterias.c2, "")
      setValue(criterias.c3, "")
    } else if (field === criterias.c1) {
      setValue(criterias.c2, "")
      setValue(criterias.c3, "")
    } else if (field === criterias.c2) {
      setValue(criterias.c3, "")
    }
    setOptions([])
  }

  return (
    <Fragment>
      <div className="w-full flex flex-col lg:flex-row gap-4">
        {criteria0?.id ? (
          <div className="w-full flex flex-col items-end justify-end gap-1">
            <TextField label="País" value={criteria0?.id} disabled />
            <p
              className="underline text-blue-500 font-medium cursor-pointer text-xs -mt-2 -ml-2"
              onClick={() => clear_field(criterias?.c0)}
            >
              Limpiar
            </p>
          </div>
        ) : (
          <SearchableSelect
            name={`shippingAddress.country`}
            control={control}
            options={options}
            onSearch={getCriteria0Action}
            placeholder="País"
            isLoading={isLoadingSearch}
            setOptions={setOptions}
            disabled={Boolean(criteria0?.id)}
          />
        )}
        {criteria1?.id ? (
          <div className="w-full flex flex-col items-end justify-end gap-1">
            <TextField label="Región" value={criteria1?.id} disabled />
            <p
              className="underline text-blue-500 font-medium cursor-pointer text-xs -mt-2 -ml-2"
              onClick={() => clear_field(criterias?.c1)}
            >
              Limpiar
            </p>
          </div>
        ) : (
          <SearchableSelect
            name={`shippingAddress.region`}
            control={control}
            options={options}
            onSearch={getCriteria1Action}
            placeholder="Región"
            isLoading={isLoadingSearch}
            setOptions={setOptions}
            disabled={Boolean(criteria1?.id || !criteria0?.id)}
          />
        )}
      </div>
      <div className="w-full flex flex-col lg:flex-row gap-4">
        {criteria2?.id ? (
          <div className="w-full flex flex-col items-end justify-end gap-1">
            <TextField label="Provincia" value={criteria2?.id} disabled />
            <p
              className="underline text-blue-500 font-medium cursor-pointer text-xs -mt-2 -ml-2"
              onClick={() => clear_field(criterias?.c2)}
            >
              Limpiar
            </p>
          </div>
        ) : (
          <SearchableSelect
            name={`shippingAddress.location.province`}
            control={control}
            options={options}
            onSearch={getCriteria2Action}
            placeholder="Provincia"
            isLoading={isLoadingSearch}
            setOptions={setOptions}
            disabled={Boolean(criteria2?.id || !criteria1?.id)}
          />
        )}
        {criteria3?.id ? (
          <div className="w-full flex flex-col items-end justify-end gap-1">
            <TextField label="Comuna" value={criteria3?.id} disabled />
            <p
              className="underline text-blue-500 font-medium cursor-pointer text-xs -mt-2 -ml-2"
              onClick={() => clear_field(criterias?.c3)}
            >
              Limpiar
            </p>
          </div>
        ) : (
          <SearchableSelect
            name={`shippingAddress.location.commune`}
            control={control}
            options={options}
            onSearch={getCriteria3Action}
            placeholder="Comuna"
            isLoading={isLoadingSearch}
            setOptions={setOptions}
            disabled={Boolean(criteria3?.id || !criteria2?.id)}
          />
        )}
      </div>
      {/* <div className="w-full flex flex-row items-end justify-end gap-4">
        <p className="underline text-blue-500 font-medium cursor-pointer text-xs" onClick={clearCriterias}>
          Reestablecer criterias
        </p>
      </div> */}
    </Fragment>
  )
}

export default CriteriasScheduleOrder
